import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import useRestoreFocus from 'utils/hooks/useRestoreFocus';
import Close from 'common/icons/CloseForm';
import { containerPaddingM, uiTransitionDurationShort } from 'common/styles/variables';

import {
    DEFAULT_FORM_BUTTON_COLOR,
    DEFAULT_FORM_BUTTON_COLOR_HOVER,
    DEFAULT_FORM_BUTTON_COLOR_FOCUS,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getFormCloseButtonStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { withFormId } from '../FormIdContext';

const CloseButtonContainer = styled.button`
    position: absolute;
    right: 0;
    z-index: 1;
    border: none;
    outline: none;
    padding: ${containerPaddingM};
    color: ${(props) => props.closeButtonColor};
    cursor: pointer;
    transition: color ${uiTransitionDurationShort} linear;
    background-color: transparent;

    &:hover {
        color: ${(props) => props.closeButtonColorHover};
    }
    &:focus {
        border: ${(props) => props.closeButtonColorFocus} 2px solid;
    }
`;

const BASE_COMPONENT_NAME = 'FormCloseButton';

const FormCloseButton = ({ closeButtonColor, closeButtonColorHover, closeButtonColorFocus, onRequestClose }) => {
    useRestoreFocus();

    return (
        <CloseButtonContainer
            closeButtonColor={closeButtonColor.value}
            closeButtonColorHover={closeButtonColorHover.value}
            closeButtonColorFocus={closeButtonColorFocus.value}
            onClick={onRequestClose}
            data-qa={BASE_COMPONENT_NAME}
            aria-label="Close"
        >
            <Close />
        </CloseButtonContainer>
    );
};

FormCloseButton.propTypes = {
    closeButtonColor: styleShapePropTypes,
    closeButtonColorHover: styleShapePropTypes,
    closeButtonColorFocus: styleShapePropTypes,
    onRequestClose: PropTypes.func.isRequired,
};

FormCloseButton.defaultProps = {
    closeButtonColor: getDefaultStyle(DEFAULT_FORM_BUTTON_COLOR),
    closeButtonColorHover: getDefaultStyle(DEFAULT_FORM_BUTTON_COLOR_HOVER),
    closeButtonColorFocus: getDefaultStyle(DEFAULT_FORM_BUTTON_COLOR_FOCUS),
};

const mapStateToProps = (state, props) => {
    const { formId } = props;
    const {
        default: closeButtonColor,
        hover: closeButtonColorHover,
        focus: closeButtonColorFocus,
    } = getFormCloseButtonStyles(state, formId);

    return {
        closeButtonColor,
        closeButtonColorHover,
        closeButtonColorFocus,
    };
};

export default withFormId(connect(mapStateToProps, {})(FormCloseButton));
